import { useEffect, useState } from "react";
import { Form, Divider, Row, Col, Collapse, Checkbox, Skeleton, Button, message, Popconfirm } from "antd";
import { ModalComponent, SaveButton, CancelButton, trans, InputText, InputTextArea, InputDate, TableWithFilter, TableComponent, SelectResourceList } from "@comps/components"
import { Commons, Const } from "../../constants"
import { getPreviewReq } from "@mods/common/requests";
import { makeRequest } from "@utils/helpers";
import dayjs from 'dayjs'
import ViewPolicySlabList from "@mods/common/ViewPolicySlabList";
import { addPolicyEmployeesReq, deletePolicyEmployeeReq, getDataByIdReq, updateDataReq } from "../requests";
import { DeleteOutline } from "@mui/icons-material";
import { makeFieldLabel } from "@utils/fieldTooltips";
import { organizationTooltips } from "../../common/organizationTooltips";
const ViewGroup = (props) => {
  const langKey = Const["group"].lngKey
  const fieldLabel = makeFieldLabel(organizationTooltips.generic, { namespace: "generic", label: (key) => trans(`${langKey}.${key}`) });
  const langKeyTravelPolicy = Const["group"].lngKey
  const formName = "createMyRoaster";
  const [loading, setLoading] = useState(true);
  const [loader, setLoader] = useState(false);
  const [record, setRecord] = useState()
  const [employees, setEmployees] = useState([])
  const [activeItem, setActiveItem] = useState(null); // State to track the active accordion item
  const [items, setItems] = useState([])
  const [form] = Form.useForm()
  const [employmentForm] = Form.useForm()
  const [employmentIds, setEmploymentIds] = useState([]);
  const [groupId, setGroupId] = useState([]);

  useEffect(() => {
    getPreview()
  }, [props])


  const handleItemClick = (item) => {
    setActiveItem(item);
  };

  const getPreview = () => {
    let payload = { moduleName: 'group', group: props.record, id: props.record.id };
    makeRequest(setLoader, getDataByIdReq, payload, setData, null);
  }

  const setData = (response) => {

    setLoading(false)
    setEmployees(response.employments)
    setRecord(response)
    setGroupId(response.id)
    form.setFieldsValue({
      name: response.name,

    })

    let data = response;
    let tempItems = [];
    Object.keys(data).forEach((each, key) => {
      if (typeof data[each] === 'object' && data[each] && data[each].id !== undefined && data[each].name !== undefined) {

        tempItems.push(
          {
            key: key,
            label: toTitleCase(each),
            children: getChildren(data, each)
          }
        )
      }
    });
    setItems(tempItems)
  }
  const getChildren = (data, each) => {
    const slabFields = [

    ]
    return (
      <>
        <Form { ...formLayout } name={ formName } disabled={ props.disabled } initialValues={ data[each] }>
          <Row gutter={ 30 }>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="name" rules={ rules.name } label={ fieldLabel("name", trans(Commons.name)) }
                className="da-mb-16"

              >
                <InputText placeholder={ trans(`${langKey}.name`) } />
              </Form.Item>
            </Col>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="description" rules={ rules.description } label={ fieldLabel("description", trans(Commons.description)) }
                className="da-mb-16"

              >
                <InputTextArea placeholder={ trans(`${langKey}.description`) } />
              </Form.Item>
            </Col>
          </Row>

          <Divider> { trans(Commons.slabs) }</Divider>

          { data[each].slabs !== undefined && data[each].slabs.length > 0 &&
            <ViewPolicySlabList fields={ slabFields } disabled={ props.disabled } type='planner' />
          }


        </Form>
      </>
    )

  }
  function toTitleCase(str) {
    return str
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  const onChangeEmployee = (ids) => {

    setEmploymentIds(ids);
  }

  const handleDeleteEmployee = (empId) => {
    const payload = {
      group_id: props.record.id, employment_id: empId
    }
    makeRequest(setLoader, deletePolicyEmployeeReq, payload, onSuccessDeleted, onError);
  }
  const onAddSelectedEmployees = () => {

    if (employmentIds.length < 1) {
      message.warning("Please select at least one employee");
      return;
    }
    const payload = {
      group: {
        group_id: props.record.id, employment_ids: employmentIds
      }
    }
    makeRequest(setLoader, addPolicyEmployeesReq, payload, onSuccessAdded, onError);
  }
  const onSuccessAdded = (response) => {

    message.success("Employees added successfully");
    employmentForm.setFieldValue("employment_ids", null);
    getPreview()
  };
  const onSuccessDeleted = (response) => {

    message.success("Deleted successfully");
    employmentForm.setFieldValue("employment_ids", null);
    getPreview()
  };

  const onError = (err, res) => {

    message.error(res.response.data.message);
    //setErrors(errorList);
  }


  const onSubmit = (data) => {

    let employmentIds = [];
    employees.forEach(employee => {
      employmentIds.push(employee.id)
    })
    data.selected_employments = employmentIds;
    //setSaveLoader(true)
    let payload = { group: data, id: props.record.id };
    makeRequest(setLoader, updateDataReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {

    if (data.errors !== undefined && data.errors.length > 0) {
      message.error(`${data.errors[0].reason}`);
      return;
    }
    else {
      message.success("Saved successfully");
    }
    //props.onCompleted(data.policy_planers.data);
    props.onCreated(data)
  }


  const footer = [
    props.disabled ? '' :
      <SaveButton form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCreated(false) } />
  ];
  //=============
  return (
    <>
      <ModalComponent top={ 20 } width={ 1200 } maskClosable={ false }
        mainTitle={ props.addEmployees ? "Add Employees" : Commons.view } subTitle={ trans(`${langKey}.moduleName`) }
        visible={ true } footer={ footer } onCancel={ () => props.onCreated(false) }>
        <Skeleton loading={ loading }>
          <Form { ...formLayout } name={ formName } form={ form } disabled={ false } onFinish={ onSubmit }>
            <Row gutter={ 30 }>
              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="name" rules={ rules.name } label={ fieldLabel("name", trans(`${langKey}.name`)) }
                  className="da-mb-16"

                >
                  <InputText placeholder={ trans(`${langKey}.name`) } />
                </Form.Item>
              </Col>

            </Row>

          </Form>

          < Collapse accordion items={ items } activeItem={ activeItem } onItemClick={ handleItemClick } />

          { props.addEmployees &&
            <div className="mt-5">
              <div className="mt-5">Select Employees To add in Group</div>
              <div>
                <Form form={ employmentForm } name="empform">
                  <Form.Item name="employment_ids" >
                    <SelectResourceList
                      onChange={ onChangeEmployee }
                      type="employment"
                      mode="multiple"
                    />
                  </Form.Item>
                </Form>

              </div>
              <div className="mt-4 text-center"><Button type="primary" onClick={ onAddSelectedEmployees }>Add Employees</Button></div>
            </div>
          }
          { employees.length > 0 && <>
            <h5 className="formlist-title">Employees</h5>

            <div style={ {
              overflowY: 'scroll',
              maxHeight: '50vh'
            } }>

              <TableWithFilter
                loader={ loader }
                columns={ [{
                  title: 'Name',
                  dataIndex: 'name',
                  key: 'name',
                },
                {
                  title: 'Designation',
                  dataIndex: 'designation_name',
                  key: 'designation',
                },
                {
                  title: 'Action',
                  hideFilter: true,
                  render: (text, record) => (
                    // confirm delte 
                    <Popconfirm title="Are you sure to delete this employee from this group?" onConfirm={ () => handleDeleteEmployee(record.id) }>
                      { props.addEmployees && <DeleteOutline className="text-danger" style={ { cursor: "pointer" } } /> }
                    </Popconfirm>
                  )
                }

                ] }

                data={ employees }
              />
            </div>
          </> }

        </Skeleton>
      </ModalComponent>

    </>

  )
}

export default ViewGroup


const rules = {
  start_date: [
    { required: true, message: 'Please select start date' },
  ],
  end_date: [
    { required: true, message: 'Please select end date' },
  ],
  repeat: [
    { required: true, message: 'Please enter repeat' },
  ],
  font_colour: [
    { required: true, message: 'Please enter font colour' },
  ],
  bg_colour: [
    { required: true, message: 'Please enter bg colour' },
  ],
  days: [
    { required: true, message: 'Please Select At least one day' },
  ],

};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}
